<script>
    import { navigate } from "svelte-routing";
    import Section from "../../components/Section.svelte";
    import EmailAdress from "../../components/account/EmailAdress.svelte";
</script>

<Section title="E-Mail-Adresse">
    <button slot="button" on:click={() => navigate("/account/email")}>E-Mail ändern</button>
    <EmailAdress />
</Section>
<hr>
<Section title="Passwort">
    <button slot="button" on:click={() => navigate("/account/passwort")}>Passwort ändern</button>
</Section>
<hr>
<Section title="Account löschen">
    <button slot="button" on:click={() => navigate("/account/loeschen")}>löschen</button>
</Section>


<style>
    button {
        color: #666;
        background-color: #F0F0F0;
        border: transparent;
        border-radius: 0.5rem;
        padding: 0 1rem;
        line-height: 2rem;
        margin: 0;
    }
</style>